import { useQuery } from '@tanstack/react-query';
import { http } from 'services/http';
import { TRANSPORT_TACHO_INFO } from 'api/query-keys.ts';
import type { TTachoInfoRes } from 'api/swagger';

interface IParams {
  isEnabled?: boolean;
}

export const useGetTachoInfo = (params?: IParams) => {
  const { isEnabled = true } = params || {};

  return useQuery<TTachoInfoRes[]>({
    queryKey: [TRANSPORT_TACHO_INFO],
    queryFn: async () => {
      const { data } = await http.get<TTachoInfoRes[]>('/v1/transports/tacho');

      return data;
    },
    retry: false,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
    enabled: isEnabled,
  });
};
